import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule  } from  'ngx-ui-loader';
import { AsistenciasComponent } from './asistencia/asistencia.component';
import { EditAsistenciaMotivoComponent } from './change/changemotivo.component';

@NgModule({
	imports:[
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgxDatatableModule,
		NgxUiLoaderModule,
		NgxUiLoaderRouterModule,
		NgxUiLoaderHttpModule
	],
	declarations:[AsistenciasComponent,EditAsistenciaMotivoComponent],
	entryComponents:[AsistenciasComponent,EditAsistenciaMotivoComponent],
})
export class ModalAsistenciasModule { }
